import { useTranslation } from "react-i18next";

import { useEnableGcpAccount } from "featureFlags/hooks/useEnableGcpAccount";

import Expand from "assets/icons/workspace/Header/ExpandSidebar.svg?react";

import { useLayoutToggles } from "components/LayoutToggles/context";

import { useLeftSidebarContext } from "../context";
import ArrowLeft from "./Arrow.svg?react";

import styles from "./styles.module.scss";

export const CollapsedHeader = () => {
  const { layout, setLayout } = useLayoutToggles();
  const { t } = useTranslation();
  const enabledGcpAccount = useEnableGcpAccount();
  const { setWidth } = useLeftSidebarContext();
  const handleToggleExpand = () => {
    setLayout({
      ...layout,
      engines: {
        ...layout.engines,
        expanded: true,
      },
    });
    setWidth(515);
  };

  return (
    <div className={styles.header}>
      <span className={styles.header__title}>
        {t("workspace.engines.title")}
        <ArrowLeft style={{ opacity: 0 }} />
      </span>
      {!enabledGcpAccount && (
        <button
          className={styles.expand}
          onClick={handleToggleExpand}
          data-testid="expand-engines-explorer-btn"
        >
          <Expand className={styles.expand__icon} />
        </button>
      )}
    </div>
  );
};
